// extracted by mini-css-extract-plugin
module.exports = {"productName":"ProductDetailsCtaMobileProductData_productName__hbPhn","productPrice":"ProductDetailsCtaMobileProductData_productPrice___WWiY"};